import { type TagAttributes } from './generated/TagAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface Tag extends TagAttributes, IColorAttribute {}

@model
@ColorAttribute()
class Tag extends ApplicationModel {
  // Start auto-generated
  static typename: 'Tag' = 'Tag';
  get typename(): 'Tag' {
    return 'Tag';
  }

  static internalTypename: 'Tag' = 'Tag';
  get internalTypename(): 'Tag' {
    return 'Tag';
  }

  static filterType = 'TagFilters!';
  static filters = { id: '[ID!]' };

  static fields = {
    color: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    tagType: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated
}

export default Tag;
